<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="toc_h"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">CONTENTS</span></p>
<p class="toc_fm" id="rsec1"><a href="#/text/Acknowledgments#sec1"><i>Acknowledgments</i></a></p>
<p class="toc_fm1" id="rsec2"><a href="#/text/Introduction#sec2">Introduction: Gendered Genealogies</a></p>
<p class="toc_ch" id="rsec3"><a href="#/text/Chapter01#sec3">1.<span class="space">Lovers and Brothers</span></a></p>
<p class="toc_ch" id="rsec4"><span href="#/text/Chapter02#sec4" title="Link target outside of Sample">2.<span class="space">Eros, Bodies, and Beyond</span></span></p>
<p class="toc_ch" id="rsec5"><span href="#/text/Chapter03#sec5" title="Link target outside of Sample">3.<span class="space">Filial and Fraternal Friends</span></span></p>
<p class="toc_ch" id="rsec6"><span href="#/text/Chapter04#sec6" title="Link target outside of Sample">4.<span class="space">Scandalous Siblings</span></span></p>
<p class="toc_ch" id="rsec7"><span href="#/text/Chapter05#sec7" title="Link target outside of Sample">5.<span class="space">Sacrificial Mothers, Sacrificial Sisters</span></span></p>
<p class="toc_fm2" id="rsec8"><span href="#/text/Epilogue#sec8" title="Link target outside of Sample">Epilogue: Beyond the Fraternal Family</span></p>
<p class="toc_fm" id="rsec9"><span href="#/text/Bibliography#sec9" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc_fm" id="rsec10"><span href="#/text/Index#sec10" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?571e3919